var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c("admin-preloader", { attrs: { show: _vm.loading } }),
      _vm._v(" "),
      _c("admin-breadcrumb", {
        attrs: {
          items: [{ text: "Reports", path: { name: "admin-reports" } }],
          name: "Monthly Account Revenue",
          title: _vm.pageTitle,
        },
      }),
      _vm._v(" "),
      _c(
        "admin-panel",
        {
          attrs: { "with-header": "" },
          scopedSlots: _vm._u([
            {
              key: "header",
              fn: function () {
                return [
                  _c("div", { staticClass: "monthly-revenue-header" }, [
                    _c("div", { staticClass: "monthly-revenue-filters" }, [
                      _c(
                        "div",
                        { staticClass: "monthly-revenue-filter" },
                        [
                          _c(
                            "label",
                            { attrs: { for: "revenue-state-filter" } },
                            [_vm._v("State")]
                          ),
                          _vm._v(" "),
                          _c("b-form-select", {
                            attrs: {
                              id: "revenue-state-filter",
                              options: _vm.stateOptions,
                            },
                            on: { change: _vm.onFiltersChanged },
                            model: {
                              value: _vm.filters.state,
                              callback: function ($$v) {
                                _vm.$set(_vm.filters, "state", $$v)
                              },
                              expression: "filters.state",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "monthly-revenue-filter" },
                        [
                          _c(
                            "label",
                            { attrs: { for: "subscription-plan-filter" } },
                            [
                              _vm._v(
                                "\n              Subscription Plan\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("b-form-select", {
                            attrs: {
                              id: "subscription-plan-filter",
                              options: _vm.subscriptionPlanOptions,
                            },
                            on: { change: _vm.onFiltersChanged },
                            model: {
                              value: _vm.filters.subscription_plan_id,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.filters,
                                  "subscription_plan_id",
                                  $$v
                                )
                              },
                              expression: "filters.subscription_plan_id",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "monthly-revenue-filter" },
                        [
                          _c("label", { attrs: { for: "addon-filter" } }, [
                            _vm._v("Add-On"),
                          ]),
                          _vm._v(" "),
                          _c("b-form-select", {
                            attrs: {
                              id: "addon-filter",
                              options: _vm.addonOptions,
                            },
                            on: { change: _vm.onFiltersChanged },
                            model: {
                              value: _vm.filters.addon_id,
                              callback: function ($$v) {
                                _vm.$set(_vm.filters, "addon_id", $$v)
                              },
                              expression: "filters.addon_id",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "monthly-revenue-filter monthly-revenue-filter--search",
                        },
                        [
                          _c(
                            "label",
                            { attrs: { for: "revenue-company-search" } },
                            [
                              _vm._v(
                                "\n              Company / Account\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("b-form-input", {
                            attrs: {
                              id: "revenue-company-search",
                              placeholder:
                                "Search by company name or account ID",
                            },
                            on: { input: _vm.onSearchInput },
                            model: {
                              value: _vm.filters.search,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.filters,
                                  "search",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "filters.search",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "monthly-revenue-actions" },
                      [
                        _c(
                          "b-btn",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover",
                                modifiers: { hover: true },
                              },
                            ],
                            staticClass: "mr-2",
                            attrs: {
                              variant: "primary",
                              title: "Export CSV",
                              disabled: !_vm.rows.length,
                            },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.downloadCsv.apply(null, arguments)
                              },
                            },
                          },
                          [_c("b-icon-download")],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-btn",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover",
                                modifiers: { hover: true },
                              },
                            ],
                            attrs: {
                              variant: "primary",
                              title: "Reload Report",
                            },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.loadReport.apply(null, arguments)
                              },
                            },
                          },
                          [_c("b-icon-arrow-clockwise")],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          _c("div", { staticClass: "revenue-summary mb-4" }, [
            _c("div", { staticClass: "revenue-summary-card" }, [
              _c("div", { staticClass: "revenue-summary-card__label" }, [
                _vm._v("\n          Base Monthly Revenue\n        "),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "revenue-summary-card__value" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.formatCurrency(_vm.summary.total_base_monthly_revenue)
                    ) +
                    "\n        "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "revenue-summary-card" }, [
              _c("div", { staticClass: "revenue-summary-card__label" }, [
                _vm._v("\n          Add-On Monthly Revenue\n        "),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "revenue-summary-card__value" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.formatCurrency(
                        _vm.summary.total_addon_monthly_revenue
                      )
                    ) +
                    "\n        "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "revenue-summary-card revenue-summary-card--total",
              },
              [
                _c("div", { staticClass: "revenue-summary-card__label" }, [
                  _vm._v(
                    "\n          Total Monthly Recurring Revenue\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "revenue-summary-card__value" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.formatCurrency(
                          _vm.summary.total_monthly_recurring_revenue
                        )
                      ) +
                      "\n        "
                  ),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("b-table", {
            attrs: {
              fields: _vm.columns,
              items: _vm.rows,
              "table-class": "text-nowrap",
              responsive: "",
              hover: "",
              "show-empty": "",
              "empty-text": "No paid accounts found",
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "cell(company_name)",
                  fn: function (data) {
                    return [
                      _c("div", { staticClass: "company-name-cell" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(data.item.company_name) +
                            "\n        "
                        ),
                      ]),
                    ]
                  },
                },
                _vm._l(_vm.sortableColumns, function (column) {
                  return {
                    key: `head(${column.key})`,
                    fn: function () {
                      return [
                        _c(
                          "button",
                          {
                            key: `sort-${column.key}`,
                            staticClass:
                              "report-sort-head btn btn-link p-0 d-inline-flex align-items-center",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.toggleSort(column.key)
                              },
                            },
                          },
                          [
                            _c("span", [_vm._v(_vm._s(column.label))]),
                            _vm._v(" "),
                            _c("span", { staticClass: "ml-2" }, [
                              _vm._v(_vm._s(_vm.sortIcon(column.key))),
                            ]),
                          ]
                        ),
                      ]
                    },
                    proxy: true,
                  }
                }),
                {
                  key: "cell(base_monthly_amount)",
                  fn: function (data) {
                    return [
                      _c("span", { staticClass: "base-revenue-value" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.formatCurrency(data.item.base_monthly_amount)
                            ) +
                            "\n        "
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: "cell(addons)",
                  fn: function (data) {
                    return [
                      data.item.addons.length
                        ? _c(
                            "div",
                            { staticClass: "addon-list" },
                            _vm._l(data.item.addons, function (addon) {
                              return _c(
                                "div",
                                {
                                  key: `${data.item.account_id}-${addon.id}`,
                                  staticClass: "addon-list__item",
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "addon-list__name" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(addon.name) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "addon-list__amount" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.formatCurrency(
                                              addon.monthly_amount
                                            )
                                          ) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            }),
                            0
                          )
                        : _c("span", [_vm._v("-")]),
                    ]
                  },
                },
                {
                  key: "cell(total_addon_amount)",
                  fn: function (data) {
                    return [
                      _c("span", { staticClass: "addon-revenue-value" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.formatCurrency(data.item.total_addon_amount)
                            ) +
                            "\n        "
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: "cell(total_monthly_amount)",
                  fn: function (data) {
                    return [
                      _c("strong", { staticClass: "total-revenue-value" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.formatCurrency(data.item.total_monthly_amount)
                            ) +
                            "\n        "
                        ),
                      ]),
                    ]
                  },
                },
              ],
              null,
              true
            ),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }